import { render, staticRenderFns } from "./PopHover.vue?vue&type=template&id=c0135868&scoped=true"
import script from "./PopHover.vue?vue&type=script&lang=js"
export * from "./PopHover.vue?vue&type=script&lang=js"
import style0 from "./PopHover.vue?vue&type=style&index=0&id=c0135868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0135868",
  null
  
)

export default component.exports